import { render, staticRenderFns } from "./bookingsubmit.vue?vue&type=template&id=495933ab&scoped=true"
import script from "./bookingsubmit.vue?vue&type=script&lang=js"
export * from "./bookingsubmit.vue?vue&type=script&lang=js"
import style0 from "./bookingsubmit.vue?vue&type=style&index=0&id=495933ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495933ab",
  null
  
)

export default component.exports